import {InjectionToken} from '@angular/core';
import {All, Create, Find, Where} from 'app/shared/data/crud.interface';
import {WarehouseOrder_IndexModel} from '../models/order/_index/warehouse-order.index.model';
import {WarehouseOrderModel} from "../models/order/warehouse-order.model";
import {WarehouseOrder_CreateModel} from "../models/order/_create/warehouse-order._create.model";

/**
 * Repository für Lager-Bestellungen
 */
export type WarehouseOrderRepository =
  & All<WarehouseOrder_IndexModel>
  & Find<WarehouseOrderModel>
  & Where<WarehouseOrder_IndexModel>
  & Create<WarehouseOrder_CreateModel, WarehouseOrderModel>;

// InjectionToken für das WarehouseOrderRepository
export const WAREHOUSE_ORDER_REPOSITORY =
  new InjectionToken<WarehouseOrderRepository>('WAREHOUSE_ORDER_REPOSITORY');
